import React from "react"
import * as S from "./Body.styles"

export default function Body({ children }) {
  return <S.Body>{children}</S.Body>
}
